<template>
  <v-dialog
    v-model="show"
    :max-width="max_width"
    @click:outside="close"
    @keydown.esc="close"
  >
    <v-card>
      <v-card-title>
        <span class="headline">{{ formTitle }}</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-row dense>
            <v-col v-if="isTraditional||isAdmin">
              <v-text-field
                v-model="item.name_tc"
                :label="$t('supplier.name_tc')"
              >
                <template
                  #label
                  v-if="action==action_items.create"
                >
                  <span class="red--text"><strong>* </strong></span>{{ $t('supplier.name_tc') }}
                </template>
              </v-text-field>
            </v-col>
            <v-col v-if="isSimplified||isAdmin">
              <v-text-field
                v-model="item.name_sc"
                :label="$t('supplier.name_sc')"
              >
                <template
                  #label
                  v-if="action==action_items.create"
                >
                  <span class="red--text"><strong>* </strong></span>{{ $t('supplier.name_sc') }}
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <LinkedAccountRow
            v-if="action == action_items.edit && show"
            :url="'/supplier/supplier/' + item.id + '/'"
            :label="$t('supplier.account')"
          ></LinkedAccountRow>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-btn @click="close">{{ $t("cancel") }}</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="action != action_items.view"
          color="primary"
          :disabled="disableSave"
          @click="save"
        >{{ $t("save") }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import BaseDialog from "./BaseDialog";
import LinkedAccountRow from "./LinkedAccountRow";
export default {
  data: (vm) => ({
    topic: vm.$i18n.t("supplier.supplier"),
  }),
  components: { LinkedAccountRow },
  mixins: [BaseDialog],
};
</script>
